import { ProductStatusConstant } from '../constants/product/product.constant';
import { IOpenMarketProduct, IProduct } from '../interfaces/Product.interfaces';
import { getOpenMarketProductTitle } from './getter/getOpenMarketProductTitle.util';

export const mapOpenMarketProductToCommonListView = (product: IOpenMarketProduct): IProduct => {
  return {
    ...product,
    price: product.hopeSellingPrice,
    category: 'OPEN_MARKET',
    title: getOpenMarketProductTitle(product),
    startOnSaleDate: new Date(product.approvalDate),
  };
};
